import { render, staticRenderFns } from "./canalM.vue?vue&type=template&id=c493786c&scoped=true&"
import script from "./canalM.vue?vue&type=script&lang=js&"
export * from "./canalM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c493786c",
  null
  
)

export default component.exports